class GravityFormsConditionalLogic {
	constructor( formElement, args = {} ) {
		this.form = formElement;
		this.args = args;
		this.formId = formElement.dataset.formid;
		this.fieldsWithLogic = formElement.querySelectorAll( '.has-conditional-logic' );
		this.relatedFields = formElement.querySelectorAll( '.conditions-related' );
		this.rules = {};

		this.init();
	}

	init() {
		this.rules = this.initRulesArray();
		this.hideElementsToShow();
		this.bindEventListeners();
		this.evaluateInitialConditions();
		this.setupAutofillDetection();
	}

	initRulesArray() {
		let rules = {};

		this.fieldsWithLogic.forEach( ( field ) => {
			// let input = field.querySelector( 'input, select, textarea' );
			let fieldRules = JSON.parse( field.dataset.rules || '[]' );
			let actionType = field.dataset.actionType;

			fieldRules.forEach( ( rule ) => {
				let key = `field_${this.formId}_${rule.fieldId}`;
				if( ! rules[ key ] ) {
					rules[ key ] = [];
				}
				rules[ key ].push( {
					id: field.id,
					operator: rule.operator,
					value: rule.value,
					action: actionType
				} );
			} );
		} );

		return rules;
	}

	hideElementsToShow() {
		this.fieldsWithLogic.forEach( ( field ) => {
			if( field.dataset.actionType === 'show' ) {
				field.classList.add( 'hidden' );
			}
		} );
	}

	bindEventListeners() {
		this.relatedFields.forEach( ( relatedField ) => {
			if( relatedField.classList.contains( 'gfield--type-checkbox' ) ) {
				relatedField.querySelectorAll( 'input[type="checkbox"]' ).forEach( ( checkbox ) => {
					checkbox.addEventListener( 'change', ( e ) => {
						this.testElement( relatedField, e.target );
					} );
				} );
			} else {
				let input = relatedField.querySelector( 'input, select, textarea' );
				if( input ) {
					input.addEventListener( 'change', ( e ) => {
						this.testElement( relatedField, e.target );
					} );
				}
			}
		} );
	}

	evaluateInitialConditions() {
		this.relatedFields.forEach( ( relatedField ) => {
			let firstInput = relatedField.querySelector( 'input, select, textarea' );
			if( firstInput ) {
				this.testElement( relatedField, firstInput );
			}
		} );
	}

	setupAutofillDetection() {
		window.addEventListener( 'load', () => {
			setTimeout( () => this.evaluateInitialConditions(), 100 );
		} );

		document.addEventListener( 'DOMContentLoaded', () => {
			setTimeout( () => this.evaluateInitialConditions(), 300 );
		} );
	}

	testElement( relatedField, changedField ) {
		if( ! this.rules[ relatedField.id ] ) return;

		let fieldValue;
		if( changedField.type === 'checkbox' ) {
			fieldValue = Array.from( relatedField.querySelectorAll( 'input[type="checkbox"]:checked' ) ).map( ( checkbox ) => checkbox.value );
		} else {
			fieldValue = changedField.value;
		}

		this.rules[ relatedField.id ].forEach( ( rule ) => {
			let targetElement = document.getElementById( rule.id );
			if( ! targetElement ) return;

			let action = this.testConditions( fieldValue, rule.operator, rule.value )
				? rule.action
				: ( rule.action === 'hide' ? 'show' : 'hide' );

			this.showHideElement( targetElement, action, relatedField.dataset.defaultRequired );
		} );
	}

	testConditions( value, operator, compareTo ) {
		if( Array.isArray( value ) ) {
			switch( operator ) {
				case 'is':
					return value.includes( compareTo );
				case 'isnot':
					return ! value.includes( compareTo );
				case 'contains':
					return value.some( ( v ) => v.includes( compareTo ) );
				case 'starts_with':
					return value.some( ( v ) => v.startsWith( compareTo ) );
				case 'ends_with':
					return value.some( ( v ) => v.endsWith( compareTo ) );
				default:
					return false;
			}
		}

		switch( operator ) {
			case 'isnot':
				return value != compareTo;
			case '>':
				return value > compareTo;
			case '<':
				return value < compareTo;
			case 'contains':
				return value.indexOf( compareTo ) !== -1;
			case 'starts_with':
				return value.startsWith( compareTo );
			case 'ends_with':
				return value.endsWith( compareTo );
			case 'is':
			default:
				return value == compareTo;
		}
	}

	showHideElement( element, action, required ) {
		if( action === 'hide' ) {
			element.classList.add( 'hidden' );
			if( required ) {
				element.removeAttribute( 'required' );
			}
		} else {
			element.classList.remove( 'hidden' );
			if( required ) {
				element.setAttribute( 'required', '' );
			}
		}
	}
}

export default GravityFormsConditionalLogic;
